<div class="page-wrapper">
    <div class="overview-container">
        <div class="overview-wrapper">
            <div *ngFor="let printer of printerArray; index as i">
                <app-printer-status-indicator
                    [isReceivingData]="isReceivingData"
                    [index]="i"
                    [printer]="printer"
                ></app-printer-status-indicator>
            </div>
        </div>
    </div>
</div>
